import React from 'react';
import {
  NavigationButtonProps,
  NavigationButtons,
  RadioOptionsProps,
} from '@molecules/index';
import { ErrorMessages } from '@types';
import {
  RadioOptionsWithImages,
  SingleRadioOptionWithImageProps,
} from './RadioOptionsWithImages';
import MultipleRadioOptionsWithoutImages from './MultipleRadioOptionsWithoutImages';

export type MultipleOptionsWithImagesProps = {
  title?: string;
  description?: string;
  labelClassName?: string;
  errorPath?: string;
  errorMessages?: ErrorMessages[];
  onChange: (result: string) => void;
  options: Omit<SingleRadioOptionWithImageProps, 'setRadio' | 'onChange'>[];
  buttonNext: NavigationButtonProps;
  buttonPrevious: NavigationButtonProps;
  children?: React.ReactNode;
  isShowErrorSummary?: string;
};

export type MultipleOptionsWithoutImagesProps = {
  title?: string;
  labelClassName?: string;
  errorPath?: string;
  errorMessages?: ErrorMessages[];
  buttonNext: NavigationButtonProps;
  buttonPrevious: NavigationButtonProps;
  radioOptions?: RadioOptionsProps[];
  children?: React.ReactNode;
  isShowErrorSummary?: string;
};

export type MultipleOptionsTemplateProps =
  | MultipleOptionsWithImagesProps
  | MultipleOptionsWithoutImagesProps;

// typeguard to check if the props are of type MultipleOptionsWithImagesProps
const isWithImagesProps = (
  props: MultipleOptionsTemplateProps,
): props is MultipleOptionsWithImagesProps => {
  return 'options' in props;
};

export const MultipleOptionsTemplate: React.FC<MultipleOptionsTemplateProps> = (
  props,
) => {
  const {
    title,
    labelClassName,
    errorPath,
    errorMessages,
    buttonNext,
    buttonPrevious,
    isShowErrorSummary,
    children,
  } = props;
  return (
    <div className="flex flex-col gap-[20px]">
      {isWithImagesProps(props) ? (
        <RadioOptionsWithImages
          title={title}
          description={props.description}
          className={labelClassName}
          errorPath={errorPath}
          errorMessages={errorMessages}
          onChange={props.onChange}
          options={props.options}
          isLabelTextTitle={true}
          isShowErrorSummary={isShowErrorSummary}
        />
      ) : (
        <MultipleRadioOptionsWithoutImages
          pageTitle={title || ''}
          radioOptions={props.radioOptions || []}
          errorMessages={errorMessages || []}
          errorPath={errorPath || ''}
        />
      )}
      {children}
      <NavigationButtons
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
      />
    </div>
  );
};
